import React, { useCallback } from "react";
import PropTypes from "prop-types";
import { Link, useLocation } from "react-router-dom";
import { CHeaderNav, CNavItem, CNavLink } from "@coreui/react";
import _ from "lodash";

// --- Utility: convert wildcard patterns (*) to regex ---
const toRegex = (pattern) => {
  if (!pattern) return null;
  const escaped = pattern.replace(/[-/\\^$+?.()|[\]{}]/g, "\\$&");
  const regexPattern = escaped.replace(/\\\*/g, ".*");
  return new RegExp("^" + regexPattern);
};

const matchPattern = (patterns, url) => {
  const arr = Array.isArray(patterns) ? patterns : [patterns];
  return arr.some((pattern) => {
    const regex = toRegex(pattern);
    return regex?.test(url);
  });
};

const TabNavigation = ({ tabs = [], isChildTab = false }) => {
  const location = useLocation();
  const currentPath = location.pathname;

  const isActiveTab = useCallback(
    (tab) => {
      if (_.isEmpty(tab?.childTabPaths)) {
        return tab.path === "" || tab.path === currentPath;
      }
      if (tab.childTabPaths.includes(currentPath)) {
        return true;
      }
      if (
        tab.isPattern &&
        matchPattern(tab.childTabPaths ?? tab.path, currentPath)
      ) {
        return true;
      }
      return false;
    },
    [currentPath],
  );

  return (
    <CHeaderNav className="tab-navigation flex-wrap">
      {tabs.map((tab, index) => {
        const active = isActiveTab(tab);
        return (
          <CNavItem key={index}>
            <Link to={tab.path}>
              <CNavLink
                className={active ? "active" : ""}
                style={{ fontSize: isChildTab ? "16px" : "18px", cursor: 'pointer' }}
              >
                {tab.label}
              </CNavLink>
            </Link>
          </CNavItem>
        );
      })}
    </CHeaderNav>
  );
};

TabNavigation.propTypes = {
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      path: PropTypes.string.isRequired,
      childTabPaths: PropTypes.arrayOf(PropTypes.string),
      isPattern: PropTypes.bool,
    }),
  ).isRequired,
};

export default TabNavigation;
